export enum ActionTypes {
    INVOICE_TOTAL = 'INVOICE_TOTAL',
    INVOICE_SUMMARY = 'INVOICE_SUMMARY',
}
